export default {
  price: 'Price ',
  typeStr: 'Type',
  typeStr2: 'Data Type',
  duration: 'Duration',
  day: ' days',
  examine: 'Examine ',
  mytask: 'My task',
  makemoney: 'Start',
  goTask: 'Continue',
  description: 'Task description',
  requirement: 'Requirements',
  projectNo: 'You do not have the authority over this task',
  return: 'Return to task list',
  taskmanage: 'Task management',
  report: 'Report',
  limitmanage: 'Authority management',
  brief: 'Task introduction',
  dectask: 'Task description',
  rule: 'The rule of task',
  effective: 'Guideline on quality control ',
  qualified: 'Quality standard',
  releaseTime: 'Release time: ',
  detail: 'Task details',
  skill: 'Skill requirements',
  do: 'Do task',
  project0:	'Quality inspection layer',
  project1:	'task list',
  project2:	'Start quality inspection',
  project3:	'Tips',
  project4:	'skill medal needed before to do releated tasks',
  project5:	'Acquire Skill Medal'
}



// WEBPACK FOOTER //
// ./src/lang/en/project.js